export default __webpack_public_path__ + "static/media/carouselFive.03a99e26.png";